import Head from "next/head"
import MainLayout from "../../../layouts/mainLayout"
import GiftCreditList from "./components/GiftCreditList"
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

const GiftCreditPage = () => {
  return (
    <>
      <Head>
        <title>اعتبار من</title>
      </Head>
      <GiftCreditList />
    </>
  )
}

GiftCreditPage.Layout = MainLayout

export default GiftCreditPage

export async function getServerSideProps(context) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
